import { api } from "./api";
import { convertToCamel } from "@lib/convertToCamel";
import { Goal } from "@dto/Goal";
import { ListEntitiesRequest } from "@store/apiTypes";

export const goalApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getGoal: build.query<Goal, string | number>({
      query: (idOrSlug) => {
        return { url: `/goals/${idOrSlug}` };
      },
      transformResponse: (responseData) => {
        const goal = convertToCamel(responseData) as any;
        goal.directionsData = JSON.parse(goal.directionsData);
        goal.type = "Goal";
        return goal as Goal;
      },
      providesTags: (_goal, _err, id) => [{ type: "Goal", id }],
    }),
    listGoals: build.query<Goal[], ListEntitiesRequest>({
      query: (request) => {
        const queryParams = [`page=${request.page}`];

        if (request.categoryIds && request.categoryIds.length > 0) {
          request.categoryIds.forEach((id) => {
            queryParams.push(`category_ids[]=${encodeURIComponent(id)}`);
          });
        }

        if (request.exclusiveCategoryIds.length > 0) {
          request.exclusiveCategoryIds.forEach((id) => {
            queryParams.push(
              `exclusive_category_ids[]=${encodeURIComponent(id)}`,
            );
          });
        }

        const url = `/goals?${queryParams.join("&")}`;

        return { url: url };
      },
      transformResponse: (responseData) => {
        const goals = convertToCamel(responseData) as Goal[];
        goals.forEach((goal) => {
          goal.type = "Goal";
        });
        return goals;
      },
    }),
  }),
});

export const { useGetGoalQuery } = goalApi;

export const {
  endpoints: { listGoals },
} = goalApi;
